// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__L50+V","info":"styles_info__a0gIk","success":"styles_success__ehaQS","warning":"styles_warning__d5n9S","error":"styles_error__XMO7M"};